import React, { Component } from "react";
import "./ServicesSection.css";
import PlanSuggestion from "../servicesSection/planSuggestion/PlanSuggestion";
import PopularServices from "../servicesSection/popularServices/PopularServices";
import PopularOffers from "../servicesSection/popularOffers/PopularOffers";

class ServicesSection extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className="section-services" id="section-select-plan">
        <div className="container" style={{padding:0}}>

          <div className="section-services-wrapper">
            <div className="row equal-height-row">

              <div className="popular-left">
                <PopularOffers />
              </div>

              <div className="popular-gap"/>

              <div className="popular-right" style={{paddingLeft:0,paddingTop:15,paddingRight:0,paddingBottom:0}}>
                <PopularServices />
              </div>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

export default ServicesSection;
